// extracted by mini-css-extract-plugin
export default {"container":"styles_container__anD9K","title":"styles_title__BfGg3","subtitle":"styles_subtitle__neHwK","paragraph":"styles_paragraph__TH5yA"};